function mergeGametypeByTitle(json1, json2) {
    // console.log(json2)
    const gametypeMap = new Map();
    for (const item of json2) {
        gametypeMap.set(item.title_cn, item.gametype);
    }
    return json1.map(item => {
        const gametype = gametypeMap.get(item.title_cn);
        return gametype ? { ...item, gametype } : item;
    });
}
export default {
    namespaced: true,
    state: {
        datafiles: ['slot', 'hunter'],
        gamesList: [],
        currGame: {},
        sourceTargetKey: './images/'
    },
    mutations: {
        SET_GAMESLIST(state, options) {
            state.gamesList = options;
        },
        SET_CURRGAME(state, options) {
            state.currGame = options;
        }
    },
    actions: {
        async getGames({ state, commit }, payload) {
            try {
                // 抓 slot 類資料 & 合併 gametype
                const [newSlotData, slotData] = await Promise.all([
                    fetch('/data/new_slot.json').then(res => res.json()),
                    fetch('/data/slot.json').then(res => res.json())
                ]);
                const mergedSlot = mergeGametypeByTitle(newSlotData, slotData);
                let items = [];
                if (payload === 'slots') {
                    mergedSlot.forEach(item => { item.platform = 'slot'; });
                    items = mergedSlot.sort((a, b) => {
                        const dateA = new Date(a.release_date || '2025-01-01').getTime();
                        const dateB = new Date(b.release_date || '2025-01-01').getTime();
                        return dateB - dateA;
                    });
                }
                else if (payload === 'hunter') {
                    items = await fetch('/data/hunter.json').then(res => res.json());
                    items.forEach(item => { item.platform = 'hunter'; });
                    items = items.sort((a, b) => {
                        const dateA = new Date(a.release_date || '2025-01-01').getTime();
                        const dateB = new Date(b.release_date || '2025-01-01').getTime();
                        return dateB - dateA;
                    });
                }
                else if (payload === 'yp') {
                    items = await fetch('/data/yp.json').then(res => res.json());
                    items.forEach(item => { item.platform = 'yp'; });
                    items = items.sort((a, b) => {
                        const dateA = new Date(a.release_date || '2025-01-01').getTime();
                        const dateB = new Date(b.release_date || '2025-01-01').getTime();
                        return dateB - dateA;
                    });
                }
                else if (payload === 'live') {
                    items = await fetch('/data/live.json').then(res => res.json());
                    items.forEach(item => { item.platform = 'live'; });
                    items = items.sort((a, b) => {
                        const dateA = new Date(a.release_date || '2025-01-01').getTime();
                        const dateB = new Date(b.release_date || '2025-01-01').getTime();
                        return dateB - dateA;
                    });
                }
                else {
                    const [hunter, yp, live] = await Promise.all([
                        fetch('/data/hunter.json').then(res => res.json()),
                        fetch('/data/yp.json').then(res => res.json()),
                        fetch('/data/live.json').then(res => res.json())
                    ]);
                    hunter.forEach(item => { item.platform = 'hunter'; });
                    yp.forEach(item => { item.platform = 'yp'; });
                    live.forEach(item => { item.platform = 'live'; });
                    mergedSlot.forEach(item => { item.platform = 'slot'; });
                    items = [...mergedSlot, ...hunter, ...yp, ...live];
                }
                commit('SET_GAMESLIST', items);
                return items;
            }
            catch (error) {
                console.error('Failed to fetch games:', error);
            }
        },
        setCurrGame(context, options) {
            context.commit('SET_CURRGAME', options);
        }
    }
};
